import { Component, OnInit } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { JobLiveViewComponent } from './job.liveview.component';

@Component({
    selector: 'my-package',
    templateUrl: './jobs.component.html',
    imports: [JobLiveViewComponent]
})

export class JobsComponent implements OnInit {
    jobId: string;
    checkComplete = false;
    result: AgentConnectionCheckResult[];
    constructor(
        private route: ActivatedRoute,
        private http: HttpClient
    ) {
        this.jobId = this.route.snapshot.params["id"];
        
    }
    ngOnInit(): void {
        this.result = [] as AgentConnectionCheckResult[];
    }

    startJob(): void {
        this.checkComplete = false;
        this.http.post<AgentConnectionCheckResult[]>("/api/test/go", undefined)
            .toPromise()
            .then((r) => {
                this.result = r;
                this.checkComplete = true;
                return r;
            }).catch((e) => console.log(e));
    }
}

class AgentConnectionCheckResult {
    MachineName: string;
    Os: string;
    ConnectionSuccessful: boolean;
}